import moment from 'moment';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createSelector } from 'reselect';
import Header from '../components/Header';
import { AttendeeType, Page } from '../model';
import { getCurrentRoom, getCheckinResourceName, getSecondaryUser, isLoginDisabled, selectCurrentRoomTimeline, selectDefaultMeetingType } from '../store/helpers';
import { actions, ReduxPropsType, StoreState } from '../store/utils';

const getPeriods = (store: StoreState) => ({
   time: store.time,
   periods: selectCurrentRoomTimeline(store),
});

const getIsBusy = createSelector(
   getPeriods,
   ({ time, periods }) => {
      const now = moment(time);
      return (periods || []).some(p => now.isSameOrAfter(p.startTime) && now.isBefore(p.endTime))
   }
)

const withRedux = connect((state: StoreState) => ({
   currentRoom: getCurrentRoom(state),
   checkinResourceName: getCheckinResourceName(state),
   time: state.time,
   isBusy: getIsBusy(state),
   myself: getSecondaryUser(state),
   loginDisabled: isLoginDisabled(state),
   canBookAdhoc: state.config.canBookAdhoc,
   defaultMeetingType: selectDefaultMeetingType(state),

}), (dispatch: Dispatch) => ({
   dispatch,
   onLogin() {
      dispatch(actions.openPopup('secondaryLogin'))
   },
   onLogout(checkinResourceName: string | undefined) {
      if (checkinResourceName) {
         dispatch(actions.setCheckinResource(null))
      }
      dispatch(actions.secondaryLogout())
   },
}), ({ myself, defaultMeetingType, ...props }, { dispatch, ...callbacks }, ownProps) => ({
   myself,
   defaultMeetingType,
   ...props,
   ...callbacks,
   ...ownProps,
   onNew: () => {
      dispatch(actions.startBooking({ participants: myself ? [{ emailAddress: myself.emailAddress, type: AttendeeType.required }] : undefined, defaultMeetingType }))
   },
   onMyCalendar: () => {
      if (myself) {
         dispatch(actions.goToPage(Page.calendar))
      } else {
         dispatch(actions.openPopup('myCalendar'))
      }
   },
}));

export type HeaderProps = ReduxPropsType<typeof withRedux>;
export default withRedux(Header);
